import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import useCardsShowHook from '../useHooks/useCardsShowHook';
const LightestUsedSence: React.FC = () => {
    const { t } = useLang('Delta3AirStation.LightestUsedSence');
    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761554258486/light-sence-1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761554258486/light-sence-1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761650485775/light01.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761554258163/light-sence-2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761554258163/light-sence-2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761650485917/light02.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
    ];

    useCardsShowHook('#List-sence-A .sence', '#List-sence-A');

    return (
        <section className={`${styles.LightestUsedSence} GtmModuleData-section range1`} id="List-sence-A" data-section-id="LightestUsedSence">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="subtitle">{t('subtitle')}</div>
            </div>
            <div className="content-box">
                {contentList.map((item, index: number) => (
                    <div className="sence" key={index}>
                        <div className="sence-img">
                            <EcoImg alt={item.title} pc={item.pc} pad={item.pad} isOpenLazy />
                        </div>
                        <div className="sence-introduce">
                            <div className="sence-title">{item.title}</div>
                            <div className="sence-desc">{item.desc}</div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default LightestUsedSence;
